var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhitewallet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 18V19.875C22.5 20.9092 21.6585 21.75 20.625 21.75H4.5C2.8455 21.75 1.5 20.4045 1.5 18.75C1.5 18.75 1.5 6.01125 1.5 6C1.5 4.3455 2.8455 3 4.5 3H18.375C18.9967 3 19.5 3.504 19.5 4.125C19.5 4.746 18.9967 5.25 18.375 5.25H4.5C4.08675 5.25 3.75 5.586 3.75 6C3.75 6.414 4.08675 6.75 4.5 6.75H20.625C21.6585 6.75 22.5 7.59075 22.5 8.625V10.5H18.75C16.6823 10.5 15 12.1823 15 14.25C15 16.3177 16.6823 18 18.75 18H22.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 12V16.5H18.75C17.5073 16.5 16.5 15.4927 16.5 14.25C16.5 13.0073 17.5073 12 18.75 12H22.5Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhitewallet);
export default __webpack_public_path__ + "static/media/whitewallet.d543c97b96eb010867aaf95f62b030c7.svg";
export { ForwardRef as ReactComponent };